export const MuiDatePicker = {
  styleOverrides: {
    root: {
      backgroundColor: 'black',
      '.MuiPaper-root.MuiPickersPopper-paper': {
        backgroundColor: '#fff',
        '.MuiPickersCalendarHeader-label': {
          textTransform: 'capitalize',
        },
      },
    },
  },
}
